export type MappedNumericFilter = [number | null, number | null, '__range' | '__lte' | '__gte'] | [];

export const mapNumericFilter = (value: string[]): MappedNumericFilter => {
  const [min, max] = value;
  const normalizeMin = min ? +min : null;
  const normalizeMax = max ? +max : null;

  if (typeof normalizeMin === 'number' && typeof normalizeMax === 'number') {
    return [normalizeMin, normalizeMax, '__range'];
  }

  if (typeof normalizeMax === 'number') {
    return [null, normalizeMax, '__lte'];
  }

  if (typeof normalizeMin === 'number') {
    return [normalizeMin, null, '__gte'];
  }

  return [];
};
